import * as React from 'react';
import i18n from 'i18next';
import MetaInfoService from '../../../services/MetaInfoService/MetaInfoService';
import { AnalyticsEngine } from '@sprinklr/stories/analytics/AnalyticsRequest';

export interface PickerStatus {
    loading: boolean;
    valid: boolean;
    disabled: boolean;
    message: string;
}

export abstract class Picker<P, S> extends React.Component<P, S> {
    protected getStatus(
        metaInfoService: MetaInfoService,
        engine: AnalyticsEngine,
        report: string,
        data?: Array<any>,
        loading?: boolean
    ): PickerStatus {
        const result = {
            loading: false,
            valid: false,
            disabled: false,
            message: null,
        };

        const loader = MetaInfoService.getDimensionLoader(engine)
            ? MetaInfoService.getDimensionLoader(engine)
            : MetaInfoService.loaderDashboards;

        result.loading = loader?.state === 'pending' || loading;
        result.valid = engine && report ? metaInfoService.isValidReport(engine, report) : true;
        result.disabled = result.loading || !result.valid;

        if (result.loading) {
            result.message = i18n.t('Loading...');
        } else if (!result.valid) {
            result.message = i18n.t('Select a metric first');
        } else if (!data || (data && data.length)) {
            result.message = i18n.t('Select...');
        } else {
            result.message = i18n.t('No results found');
        }

        return result;
    }
}
